import { validateArrayBindings } from "../utils/validation";


function flourishifyData(input_data, column_bindings, columns_bindings) {
	return input_data.map(function(d) {
		var obj = {};

		Object.keys(column_bindings).forEach(function(key) {
			obj[key] = d[column_bindings[key]];
		});

		Object.keys(columns_bindings).forEach(function(key) {
			var a = columns_bindings[key];
			if (!Array.isArray(a)) a = [a];
			obj[key] = a.map(function(inner_key) { return d[inner_key]; });
		});

		return obj;
	});
}


function flourishifyObjects(input_data, column_bindings, columns_bindings) {
	column_bindings = column_bindings || {};
	columns_bindings = columns_bindings || {};

	var data = flourishifyData(input_data, column_bindings, columns_bindings);
	data.column_names = {};

	Object.keys(column_bindings).forEach(function(key) {
		data.column_names[key] = column_bindings[key];
	});

	Object.keys(columns_bindings).forEach(function(key) {
		var a = columns_bindings[key];
		data.column_names[key] = Array.isArray(a) ? a : [a];
	});

	return data;
}


function flourishifyArrays(input_data, column_bindings, columns_bindings) {
	column_bindings = column_bindings || {};
	columns_bindings = columns_bindings || {};
	validateArrayBindings(column_bindings, columns_bindings);
	var old_headers = input_data[0];

	var data = flourishifyData(input_data.slice(1), column_bindings, columns_bindings);
	data.column_names = {};

	Object.keys(column_bindings).forEach(function(key) {
		data.column_names[key] = old_headers[column_bindings[key]];
	});

	Object.keys(columns_bindings).forEach(function(key) {
		var a = columns_bindings[key];
		data.column_names[key] = (Array.isArray(a) ? a : [a]).map(function(k) {
			return old_headers[k];
		});
	});

	return data;
}


function flourishify(input_data, column_bindings, columns_bindings) {
	var fls = Array.isArray(input_data[0]) ? flourishifyArrays : flourishifyObjects;
	return fls(input_data, column_bindings, columns_bindings);
}


export { flourishifyObjects, flourishifyArrays, flourishify };
